import script from "./LeftSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./LeftSidebar.vue?vue&type=script&setup=true&lang=ts"

import "./LeftSidebar.vue?vue&type=style&index=0&id=01eedb92&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01eedb92"]])

export default __exports__